import { useEffect, useState } from "react";

function detectInitialEnv() {
  try {
    const mode = import.meta.env?.MODE;
    if (typeof mode === "string" && mode.length > 0) {
      return mode;
    }
  } catch {
    // ignore access errors when import.meta is unavailable
  }

  if (typeof process !== "undefined" && typeof process.env?.NODE_ENV === "string") {
    return process.env.NODE_ENV;
  }

  return "";
}

export function useEnvironment() {
  const initialEnv = detectInitialEnv();
  const [nodeEnv, setNodeEnv] = useState<string>(initialEnv);
  const [isLoading, setIsLoading] = useState(initialEnv === "");

  useEffect(() => {
    let isActive = true;

    const fetchEnv = async () => {
      try {
        const response = await fetch("/api/env");
        if (!response.ok) throw new Error("Failed to fetch");
        const data = await response.json();
        console.log("[useEnvironment] Fetched:", data);
        if (isActive && data.nodeEnv) {
          setNodeEnv(data.nodeEnv);
        }
      } catch (error) {
        console.error("[useEnvironment] Failed to fetch environment:", error);
      } finally {
        if (isActive) {
          setIsLoading(false);
        }
      }
    };

    fetchEnv();

    return () => {
      isActive = false;
    };
  }, []);

  return {
    nodeEnv,
    isTest: nodeEnv !== "production",
    isLoading,
  };
}
